import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TRADES_ACTION_TYPE } from '../actions';

const DEFAULT_PAGE_SIZE = 25;

const initialState = {
  list: [],
  currentTrade: null,
  pagination: {
    totalCount: 0,
    page: 1,
    pageSize: 25,
    totalPages: 0,
  },
};

const tradesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case TRADES_ACTION_TYPE.GET_TRADES_LIST:
        draft.list = Array.isArray(payload) ? payload : (payload.items ?? []);
        draft.pagination = Array.isArray(payload)
          ? { ...initialState.pagination, totalCount: payload.length }
          : {
              totalCount: payload.totalCount ?? 0,
              page: payload.page ?? 1,
              pageSize: payload.pageSize ?? DEFAULT_PAGE_SIZE,
              totalPages: payload.totalPages ?? 0,
            };
        break;

      case TRADES_ACTION_TYPE.GET_TRADE:
        draft.currentTrade = payload;
        break;

      case TRADES_ACTION_TYPE.CREATE_TRADE:
        draft.list = [payload, ...draft.list];
        break;

      case TRADES_ACTION_TYPE.UPDATE_TRADE:
      case TRADES_ACTION_TYPE.UPDATE_TRADE_STATUS:
        draft.currentTrade = payload;
        draft.list = draft.list.map(trade => (trade.id === payload.id ? payload : trade));
        break;

      case TRADES_ACTION_TYPE.DELETE_TRADE:
        draft.list = draft.list.filter(trade => trade.id !== meta.id);
        break;

      case TRADES_ACTION_TYPE.CLEAR_CURRENT_TRADE:
        draft.currentTrade = null;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default tradesReducer;
